import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { Observable } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { DashboardJobDto } from 'src/app/types/dto/dashboard-job.dto'
import { ProcessedDashboardJob } from 'src/app/types/datasources/job.model'
import { environment } from 'src/environments/environment'
import { AuthService } from '../auth.service'
import { HttpHelperService } from '../http.service'
import { TimedCache } from '../timed-cache'
import { UtilsService } from '../utils.service'
import { JobDto, ProcessedJob } from 'src/app/types/dto/job.dto'
import { LogService } from '../log.service'
import { JobLookupApiService } from './job-lookup.api.service'

@Injectable({
  providedIn: 'root',
})
export class JobsApiService {
  private jobLookup = inject(JobLookupApiService);
  private httpHelper = inject(HttpHelperService);
  private logger = inject(LogService);
  private utils = inject(UtilsService);
  private auth = inject(AuthService);
  private http = inject(HttpClient);

  private cachedJobs = new TimedCache<ProcessedDashboardJob[]>()

  constructor() {
    this.httpHelper.clearCaches.subscribe(() => this.cachedJobs.clear())
  }

  getJob(jobNumber: string): Observable<ProcessedJob> {
    const comp = this.auth.getCurrentCompany()
    if (!comp) {
      this.logger.log('jobs.api', 'getJob', null, 'no company')
      throw Error('no company set in getJob')
    }

    return this.http
      .get<JobDto>(environment.apiUrl + `jobs/${jobNumber}`, this.httpHelper.httpReadOnlyOptions)
      .pipe(
        map((j) => {
          const jobAddress = this.utils.generateJobAddressString(j.jobAddress)
          const contractAddress = this.utils.generateJobAddressString(j.contractAddress)
          return { ...j, contractAddress, jobAddress }
        })
      )
  }

  getJobs(): Observable<ProcessedDashboardJob[]> {
    const comp = this.auth.getCurrentCompany()
    if (!comp) {
      this.logger.log('jobs.api', 'getJobs', null, 'no company')
      throw Error('no company set in getJobs')
    }

    return this.cachedJobs.get(comp.id, () => {
      return this.http
        .get<DashboardJobDto[]>(
          environment.apiUrl + 'jobs/for-dashboard',
          this.httpHelper.httpReadOnlyOptions
        )
        .pipe(switchMap((jobs) => this.jobLookup.enrich(jobs as ProcessedDashboardJob[])))
    })
  }
}
